export const MAP_API_KEY = `${process.env.REACT_APP_MAP_API_KEY}`;
export const SOCKET_API_KEY = `${process.env.REACT_APP_SOCKET_API_KEY}`;
